import { ca } from '@cian/analytics';

export function trackScrollInformation(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Scroll',
    label,
  });
}
